module.exports = __webpack_public_path__ + "img/help-carousel.97eb273f.jpg";